import {connectionsFromResponse, hasAccountList} from '../../agency/connections_v2/platformsModel';
import {MERCADO_ADS_CHANNEL} from '../../channels/channels';

/**
 * «¿No encuentras la cuenta?» del modal Vincular cuenta, sin React ni red (cc#209).
 *
 * El caso: la cuenta de Meta de un cliente nuevo no aparecía para vincular. La conexión de Meta de la
 * agencia era de otra persona del equipo, Meta lista sólo las cuentas ASIGNADAS a esa persona, y
 * ninguna pantalla decía de quién era la conexión. Quien buscaba tenía control total del portfolio,
 * creyó que contaba su acceso y escribió a soporte. Lo que se decide para que eso no pase vive acá.
 */

const NS = 'control_central.link_account_missing';
const RAW = {escapeValue: false};

/**
 * ¿El modal ofrece la ayuda en este canal? Los de pauta con lista de cuentas, como Conexiones. Mercado
 * Ads no: sus instrucciones son de «asignarle la cuenta a una persona», y en Mercado Libre la cuenta ES
 * del vendedor (lo que falta se conecta con su cuenta principal o con el link, desde Conexiones).
 */
export function offersMissingAccountHelp(channel) {
    return hasAccountList(channel) && channel !== MERCADO_ADS_CHANNEL;
}

/** Las conexiones de ese canal, de la respuesta de `GET agency/connections/` (su `data`). */
export function connectionsOfChannel(data, channel) {
    return connectionsFromResponse(data).credentials[channel] || [];
}

/**
 * A quién hay que darle acceso, como se nombra en las instrucciones.
 *
 * Sólo se nombra a una persona cuando se sabe quién autorizó EN LA PLATAFORMA (Meta y TikTok lo dan):
 * «Lo conectó X» dice quién apretó el botón en Dashbo, que en Google o LinkedIn puede haber entrado
 * con otro usuario. Sin eso, la conexión se nombra por su nombre, que es lo que se ve en la lista.
 */
export function personText(t, connections) {
    if (connections.length === 1) {
        const [connection] = connections;
        if (connection.platform_user_name) return connection.platform_user_name;
        if (connection.label) return t(`${NS}.person_of_label`, {label: connection.label, interpolation: RAW});
    }
    return t(`${NS}.person_any`);
}

/** «la cuenta publicitaria «TouToys»» si se buscó algo; si no, «una cuenta publicitaria». */
export function accountText(t, query) {
    const name = (query || '').trim();
    return name ? t(`${NS}.account_named`, {name, interpolation: RAW}) : t(`${NS}.account_unnamed`);
}

/** El mensaje listo para mandarle a quien administra la cuenta. */
export function instructionsFor(t, channel, {query, person}) {
    return t(`${NS}.message.${channel}`, {account: accountText(t, query), person, interpolation: RAW});
}

/**
 * Las cuentas que coinciden con lo buscado, con el mismo criterio que el buscador del combo
 * (`SelectWithSearch` busca en «nombre (ID: x)»).
 */
export function accountsMatching(accounts, query) {
    const needle = (query || '').trim().toLowerCase();
    if (!needle) return [];
    return (accounts || []).filter((account) => `${account.name} (ID: ${account.id})`.toLowerCase().includes(needle));
}

/** «Vuelve a intentarlo en N min», en minutos enteros y nunca 0. */
export function minutesToWait(seconds) {
    const value = Number(seconds);
    if (!Number.isFinite(value) || value <= 0) return 1;
    return Math.max(1, Math.ceil(value / 60));
}
